import type { Theme, SxProps } from '@mui/material/styles';
import type { TablePaginationProps } from '@mui/material/TablePagination';

import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import TablePagination from '@mui/material/TablePagination';

// ----------------------------------------------------------------------

export type TablePaginationCustomProps = TablePaginationProps & {
  dense?: boolean;
  sx?: SxProps<Theme>;
  onChangeDense?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export function TablePaginationCustom({
  sx,
  dense,
  onChangeDense,
  rowsPerPageOptions = [5, 10, 25],
  ...other
}: TablePaginationCustomProps) {
  const { t } = useTranslation('translation');
  return (
    <Box sx={[{ position: 'relative' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        labelRowsPerPage={t('ROW_PER_PAGE')}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} ${t('OF')} ${count !== -1 ? count : `${t('MORE_THEN')} ${to}`}`
        }
        getItemAriaLabel={(type) => {
          switch (type) {
            case 'next':
              return t('NEXT'); // ✅ Tooltip: Go to next page
            case 'previous':
              return t('PREVIOUS');
            default:
              return '';
          }
        }}
        component="div"
        {...other}
        sx={{ borderTopColor: 'transparent' }}
      />

      {/* {onChangeDense && (
        <FormControlLabel
          label="Dense"
          control={
            <Switch checked={dense} onChange={onChangeDense} inputProps={{ id: 'dense-switch' }} />
          }
          sx={{
            pl: 2,
            py: 1.5,
            top: 0,
            position: { sm: 'absolute' },
          }}
        />
      )} */}
    </Box>
  );
}
